import React, { useState, useEffect, useRef } from "react";
import "./ContentList.scss";
import "../DashBoard/sliding.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import name from "../../images/new_ui/name_con.svg";
import uparrow from "../../images/new_ui/uparrow_con.svg";
import size from "../../images/new_ui/size_con.svg";
import date from "../../images/new_ui/date_con.svg";
import filter from "../../images/new_ui/filter_con.svg";
import imgtype from "../../images/new_ui/type_con.svg";
import deletesvg from "../../images/new_ui/deletecontent.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Typography from "@mui/material/Typography";
import AddContent from "../../components/Add_Content/AddContent";
import { Menu, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import downarrow from "../../images/new_ui/downarrow_con.svg";
// import { ReactComponent as TableRight } from "../../images/new_ui/tableright.svg";
import SearchBarComponent from "../../components/searchBar/searchBarComponent";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ContentSVG } from "../../images/new_ui/addcontent.svg";
import { ReactComponent as AddSVG } from "../../images/new_ui/addArrow.svg";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "bootstrap/dist/css/bootstrap.min.css";
import GetAppIcon from "@mui/icons-material/GetApp"; // Import download icon from MUI
import CircularProgress from "@mui/material/CircularProgress"; // Import loader from MUI


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "#1A1A1A",
  border: "1px solid #262626",
  boxShadow: 24,
  borderRadius: "5px",
  p: 4,
  height: "74%",
};
const styledelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ContentList() {
  // Dispatch function
  const navigate = useNavigate();

  const dispatch = useDispatch();

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  const [userData, setUserData] = useState([]);
  const [userValidated, setUserValidated] = useState(false);
  const [selectedcontentID, setSelectedcontentID] = useState(null);
  const [selectedcontentType, setSelectedcontentType] = useState(null);
  const [isDeleteOpen, setDeleteOpen] = useState(false);

  const [apiLoad, setApiLoad] = useState(false);
  const [noData, setNoData] = useState(false);

  const [companyFilterOpen, setCompanyFilterOpen] = useState(false);
  const [filteredContenttype, setFilteredContenttype] = useState([]);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [openPopup, setOpenPopup] = useState(false);
  const [viewedItem, setViewedItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingContent, setIsLoadingContent] = useState(false); // Added loading state for content

  const handleOpen = () => setOpenPopup(true);
  const handleClose = () => {
    setOpenPopup(false);
    getUsersList(); // Add this to refresh data when modal closes
  };

  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  async function getUsersList() {
    setApiLoad(true);
    setNoData(false);
    try {
      const response = await axios.get(
        "contentlogic/details/" +
        JSON.parse(sessionStorage.getItem("userdata")).te_companyid,
        {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("access_token"),
          },
        }
      );

      if (response.status === 200) {
        setApiLoad(false);

        setUserData(response.data.data);
        setFilteredContenttype(response.data.data);
      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } catch (err) {
      setApiLoad(false);
      if (err.response && err.response.data.message === "Data not found") {
        setNoData(true);
        setUserData([]);
        setFilteredContenttype([]);
      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        toast.error("An error occurred while fetching data. Please try again.");
      }
    }
  }

  useEffect(() => {
    getUsersList();
    getUsersSearchList();
  }, []);

  const closeContentPopup = () => {
    setOpenPopup(false);
    getUsersList();
  };

  const handleCompanyFilter = (contentType) => {
    if (contentType === "All") {
      setFilteredContenttype(userData);
    } else {
      const filteredData = userData.filter(
        (item) =>
          item.te_contenttype.toLowerCase() === contentType.toLowerCase()
      );
      setFilteredContenttype(filteredData);
    }
  };

  const getUniqueCompanies = () => {
    const uniqueCompanies = [
      "All",
      ...new Set(userData.map((item) => item.te_contenttype)),
    ];
    return uniqueCompanies;
  };

  const parseSize = (size) => {
    const sizeRegex = /^(\d+(\.\d+)?)\s*(KB|MB|GB|TB)$/i;
    const matches = size.match(sizeRegex);
    if (!matches) return 0;
    const value = parseFloat(matches[1]);
    const unit = matches[3].toUpperCase();
    switch (unit) {
      case "KB":
        return value * 1024;
      case "MB":
        return value * 1024 * 1024;
      case "GB":
        return value * 1024 * 1024 * 1024;
      case "TB":
        return value * 1024 * 1024 * 1024 * 1024;
      default:
        return 0;
    }
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(column);
      setSortDirection("asc");
    }
  };

  const getArrowImage = (column) => {
    if (sortedColumn === column) {
      return sortDirection === "asc" ? uparrow : downarrow;
    }
    return uparrow;
  };

  const sortedData = (data) => {
    if (sortedColumn) {
      return data.sort((a, b) => {
        let valueA = a[sortedColumn];
        let valueB = b[sortedColumn];

        if (sortedColumn === "te_contentname") {
          valueA = valueA.toLowerCase();
          valueB = valueB.toLowerCase();
        } else if (sortedColumn === "te_filesize") {
          valueA = parseSize(valueA);
          valueB = parseSize(valueB);
        }

        if (valueA < valueB) {
          return sortDirection === "asc" ? -1 : 1;
        }
        if (valueA > valueB) {
          return sortDirection === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return data;
  };

  const openDeleteModal = (contentID, contentType) => {
    setSelectedcontentID(contentID);
    setSelectedcontentType(contentType);

    setDeleteOpen(true);
  };
  const closeDeleteModal = () => {
    setDeleteOpen(false);
  };

  const DeleteUser = async (contentID) => {
    try {
      const response = await axios.delete(`/contentlogic/delete/${contentID}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      });
      dispatch(sidebarReducer.apiLoad(false));

      if (response.data.status === 200) {
        if (response.data.message === "CONTENT DELETED SUCCESSFULLY") {
          toast.success("CONTENT DELETED SUCCESSFULLY", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.warn(response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        setDeleteOpen(false);
        getUsersList();
      } else {
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      closeDeleteModal();
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  // Add these state variables at the top with your other state declarations
  const [downloadingFile, setDownloadingFile] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);

  // Replace your downloadFile function with this improved version// Improved downloadFile function with proper ZIP handling
  const downloadFile = async (url, filename) => {
    try {
      setDownloadingFile(true);
      setDownloadProgress(0);

      // Fix the filename extension for ZIP files
      let correctedFilename = filename;
      if (filename.toLowerCase().endsWith('.x-zip-compressed')) {
        // Replace the .x-zip-compressed extension with .zip
        correctedFilename = filename.replace(/\.x-zip-compressed$/i, '.zip');
      }

      // Check if the URL is an S3 pre-signed URL
      const isS3PreSignedUrl = url.includes("X-Amz-Algorithm") || url.includes("AWSAccessKeyId") || url.includes("Signature");

      if (isS3PreSignedUrl) {
        // For S3 URLs, we'll use fetch to get proper content type handling
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Get content type from headers or determine from filename
        let contentType = response.headers.get('Content-Type');
        
        // If we have a ZIP file, ensure proper MIME type
        if (correctedFilename.toLowerCase().endsWith('.zip') || 
            contentType === 'application/zip' ||
            contentType === 'application/x-zip-compressed') {
          contentType = 'application/zip';
        }

        // Get total size
        const contentLength = response.headers.get('Content-Length');
        const totalSize = contentLength ? parseInt(contentLength, 10) : 0;

        // Create a reader from the response body stream
        const reader = response.body.getReader();
        const chunks = [];
        let receivedSize = 0;

        // Process the stream chunks
        while (true) {
          const { done, value } = await reader.read();

          if (done) {
            break;
          }

          chunks.push(value);
          receivedSize += value.length;

          // Update progress if we know the total size
          if (totalSize > 0) {
            const progress = Math.round((receivedSize / totalSize) * 100);
            setDownloadProgress(progress);
          } else {
            // If size unknown, just increment progress
            setDownloadProgress(prev => Math.min(prev + 5, 90));
          }
        }

        // Combine chunks into a single Uint8Array
        const chunksAll = new Uint8Array(receivedSize);
        let position = 0;
        for (const chunk of chunks) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }

        // Convert to blob with proper content type
        const blob = new Blob([chunksAll], { type: contentType || 'application/octet-stream' });
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = correctedFilename; // Use the corrected filename
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Clean up the blob URL after download starts
        setTimeout(() => {
          window.URL.revokeObjectURL(downloadUrl);
          setDownloadProgress(100);
          setTimeout(() => setDownloadingFile(false), 1000);
        }, 100);
      } else {
        // For regular URLs, use fetch with progress tracking
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Get total size
        const contentLength = response.headers.get('Content-Length');
        const totalSize = contentLength ? parseInt(contentLength, 10) : 0;

        // Create a reader from the response body stream
        const reader = response.body.getReader();
        const chunks = [];
        let receivedSize = 0;

        // Process the stream chunks
        while (true) {
          const { done, value } = await reader.read();

          if (done) {
            break;
          }

          chunks.push(value);
          receivedSize += value.length;

          // Update progress if we know the total size
          if (totalSize > 0) {
            const progress = Math.round((receivedSize / totalSize) * 100);
            setDownloadProgress(progress);
          } else {
            // If size unknown, just increment progress
            setDownloadProgress(prev => Math.min(prev + 5, 90));
          }
        }

        // Combine chunks into a single Uint8Array
        const chunksAll = new Uint8Array(receivedSize);
        let position = 0;
        for (const chunk of chunks) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }

        // Convert to blob and download
        const blob = new Blob([chunksAll]);
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = correctedFilename; // Use the corrected filename
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Clean up the blob URL after download starts
        setTimeout(() => {
          window.URL.revokeObjectURL(downloadUrl);
          setDownloadProgress(100);
          setTimeout(() => setDownloadingFile(false), 1000);
        }, 100);
      }
    } catch (error) {
      console.error("Error downloading file:", error);

      // More detailed error logging
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }

      toast.error("Error downloading file. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      setDownloadingFile(false);
    }
  };

  const handleContentClick = async (item) => {
    setIsLoadingContent(true);
    setViewedItem({ ...item, loading: true });
 
    try {
      // Check if it's a video file
      const isVideo = item.te_contenttype === "video" ||
        item.te_contentname.toLowerCase().endsWith('.mp4') ||
        item.te_contentname.toLowerCase().endsWith('.avi') ||
        item.te_contentname.toLowerCase().endsWith('.mov');

      // Check if it's a PDF file based on contentname or URL
      const isPdf = item.te_contentname.toLowerCase().endsWith('.pdf') ||
        item.te_contenturl.toLowerCase().endsWith('.pdf') ||
        item.te_contentfilepath?.toLowerCase().endsWith('.pdf');

      // Check if it's a ZIP file
      const isZip = item.te_contentname.toLowerCase().endsWith('.zip') ||
      item.te_contentname.toLowerCase().endsWith('.x-zip-compressed') ||
      item.te_contenturl.toLowerCase().endsWith('.zip') ||
      item.te_contentfilepath?.toLowerCase().endsWith('.zip') ||
      item.te_contenttype === 'application/zip' ||
      item.te_contenttype === 'application/x-zip-compressed';

      // Check if the URL is an S3 pre-signed URL
      const isS3PreSignedUrl = item.te_contenturl.includes('AWSAccessKeyId') ||
        item.te_contenturl.includes('Signature') ||
        item.te_contenturl.includes('X-Amz-');

      // If it's a video file, just set loading to false immediately
      if (isVideo) {
        setViewedItem({ ...item, loading: false });
        setIsLoadingContent(false);
        return;
      }

      // Special handling for ZIP files - we'll show an info screen instead of trying to preview content
      if (isZip) {
        setViewedItem({
          ...item,
          isZip: true,
          loading: false
        });
        setIsLoadingContent(false);
        return;
      }

      if (isPdf) {
        try {
          let pdfBlob;

          if (isS3PreSignedUrl) {
            // For S3 URLs, use fetch directly WITHOUT authorization headers
            const response = await fetch(item.te_contenturl);

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            pdfBlob = await response.blob();
          } else {
            // For non-S3 URLs, use axios with responseType: 'blob' and authorization headers
            const response = await axios.get(item.te_contenturl, {
              responseType: 'blob',
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
              }
            });

            pdfBlob = response.data;
          }

          // Ensure the blob has the correct MIME type
          const pdfBlobWithType = new Blob([pdfBlob], { type: 'application/pdf' });

          // Create a blob URL from the properly typed blob
          const blobUrl = URL.createObjectURL(pdfBlobWithType);

          setViewedItem({
            ...item,
            blobUrl: blobUrl,
            isPdf: true,
            loading: false
          });
        } catch (pdfError) {
          console.error("Error fetching PDF:", pdfError);
          toast.error("Error loading PDF. Please try downloading instead.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          // Still set the item but mark as error
          setViewedItem({
            ...item,
            isPdf: true,
            pdfError: true,
            loading: false
          });
        }
      } else if (isS3PreSignedUrl) {
        // For other file types from S3, we might need similar handling
        try {
          // Do NOT include authorization headers for S3 pre-signed URLs
          const response = await fetch(item.te_contenturl);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);

          setViewedItem({ ...item, blobUrl: blobUrl, loading: false });
        } catch (error) {
          console.error("Error fetching S3 content:", error);
          setViewedItem({ ...item, blobUrl: item.te_contenturl, loading: false });
        }
      } else {
        // For non-S3, non-PDF URLs, use axios with authorization headers
        try {
          const response = await axios.get(item.te_contenturl, {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            }
          });

          // Get the content type from the response or infer it from the file name
          let contentType = response.headers["content-type"];
          if (!contentType) {
            // Try to infer content type from filename
            if (item.te_contentname.toLowerCase().endsWith('.docx')) {
              contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            } else if (item.te_contentname.toLowerCase().endsWith('.txt')) {
              contentType = 'text/plain';
            } else {
              contentType = 'application/octet-stream'; // Default binary type
            }
          }

          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);

          if (item.te_contenttype === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
            item.te_contentname.toLowerCase().endsWith('.docx')) {
            setViewedItem({ ...item, blobUrl: url, contentType: "docx", loading: false });
          } else {
            setViewedItem({ ...item, blobUrl: url, loading: false });
          }
        } catch (error) {
          console.error("Error fetching content:", error);
          setViewedItem({ ...item, loading: false, fetchError: true });
        }
      }
    } catch (error) {
      console.error("Error fetching content:", error);
      toast.error("Error fetching content. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setViewedItem(null);
    } finally {
      setIsLoadingContent(false);
    }
  };
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90vw",
    height: "90vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 0,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };
  
  

  // Define a common style for all content types
  const contentStyle = {
    maxWidth: "calc(100% - 20px)",
    maxHeight: "calc(100% - 20px)",
    objectFit: "contain",
    margin: "10px",
  };

  const isAudioFile = (filename) => {
    const audioExtensions = [".mp3", ".wav", ".ogg", ".m4a", ".aac"];
    return audioExtensions.some((ext) => filename.toLowerCase().endsWith(ext));
  };

  const audioStyle = {
    width: "60%",
    borderRadius: "8px",
    backgroundColor: "#ede2ce",
    padding: "10px",
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    getUsersSearchList(searchTerm);
  };

  async function getUsersSearchList(search = "") {
    dispatch(sidebarReducer.apiLoad(true));
    try {
      const url = `contentlogic/details/${JSON.parse(sessionStorage.getItem("userdata")).te_companyid
        }`;
      const params = search ? { s: search } : {};

      const response = await axios.get(url, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      });

      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));

        setUserData(response.data.data);
        setFilteredContenttype(response.data.data);
      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } catch (err) {
      dispatch(sidebarReducer.stringUpdate("AppDown"));

      if (err.response.data.message === "Data not found") {
        dispatch(sidebarReducer.apiLoad(false));
      } else {
        toast.error("An error occurred while searching. Please try again.");
      }
    }
  }

  const highlightText = (text, highlight) => {
    if (!highlight.trim()) {
      return text;
    }
    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedHighlight})`, "gi");
    return text.replace(regex, '<span class="highlighted-text">$1</span>');
  };

  // Button style for download buttons
  const downloadButtonStyle = {
    padding: "8px 16px",
    backgroundColor: "#FFD119",
    color: "black",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    margin: "10px 0",
  };

  return (
    <div className="content-list">
      {!openPopup && <ToastContainer closeButton={false} />}
      <div className="container-fluid">
        <div className="search-section row">
          <SearchBarComponent
            className="search-bar-div"
            value={searchTerm}
            onChange={handleSearchChange}
            onSubmit={handleSearchSubmit}
          />

          <button className="add-button" type="button" onClick={handleOpen}>
            <div className="centered-div">
              <ContentSVG
                style={{
                  width: "40px",
                  height: "auto",
                  margin: "0px 10px",
                  cursor: "pointer",
                }}
              />

              <p>Add Content</p>
            </div>
            <div className="next-buttons">
              <AddSVG
                style={{
                  width: "15px",
                  height: "auto",
                  margin: "0px 5px",
                  cursor: "pointer",
                }}
              />
            </div>
          </button>
        </div>

        <div className="container">
          <div className="content-list-container">
            <h5>Content List</h5>

            {apiLoad ? (
              <div
                style={{
                  height: "80vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="spinnerApi"></div>
              </div>
            ) : noData ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p>No content available. Add some content to get started!</p>
              </div>
            ) : (
              <div style={{ height: "93%" }}>
                <div
                  className="container-fluid g-0 table-custom"
                  style={{ height: "100%" }}
                >
                  <div className="table-wrapper-scroll-y user-list-table">
                    <>
                      <table
                        key={JSON.stringify(userData)}
                        stickyHeader
                        aria-label="sticky table"
                      >
                        <thead>
                          <tr>
                            <th>
                              <img
                                src={name}
                                className="name-icon"
                                alt="Filter"
                              />
                              Name
                              <img
                                className="uparrow-icon"
                                src={getArrowImage("te_contentname")}
                                onClick={() => handleSort("te_contentname")}
                                alt={
                                  sortDirection === "asc"
                                    ? "Sort Ascending"
                                    : "Sort Descending"
                                }
                              />
                            </th>

                            <th>
                              <img
                                src={size}
                                className="size-icon"
                                alt="Filter"
                              />
                              Size
                              <img
                                className="uparrow-icon"
                                src={getArrowImage("te_filesize")}
                                onClick={() => handleSort("te_filesize")}
                                alt={
                                  sortDirection === "asc"
                                    ? "Sort Ascending"
                                    : "Sort Descending"
                                }
                              />
                            </th>
                            <th id="company-filter-icon">
                              <div
                                onClick={() =>
                                  handleSort("item.te_contenttype")
                                }
                              >
                                <img
                                  src={imgtype}
                                  alt="Filter"
                                  className="type-icon"
                                />{" "}
                                Type
                                <img
                                  className="filter-icon"
                                  src={filter}
                                  alt="Filter"
                                  onClick={() =>
                                    setCompanyFilterOpen(!companyFilterOpen)
                                  }
                                />
                              </div>
                              <Menu
                                anchorEl={document.getElementById(
                                  "company-filter-icon"
                                )}
                                open={companyFilterOpen}
                                onClose={() => setCompanyFilterOpen(false)}
                              >
                                {getUniqueCompanies().map((item, index) => (
                                  <MenuItem
                                    key={index}
                                    onClick={() => {
                                      handleCompanyFilter(item);
                                      setCompanyFilterOpen(false);
                                    }}
                                  >
                                    {item}
                                  </MenuItem>
                                ))}
                              </Menu>
                            </th>
                            <th>
                              <img
                                src={date}
                                className="date-icon"
                                alt="Filter"
                              />
                              Date
                              <img
                                className="filter-icon"
                                src={getArrowImage("te_contentdate")}
                                onClick={() => handleSort("te_contentdate")}
                                alt={
                                  sortDirection === "asc"
                                    ? "Sort Ascending"
                                    : "Sort Descending"
                                }
                              />
                            </th>
                            <th>
                              <img
                                src={date}
                                className="date-icon"
                                alt="Filter"
                              />
                              Sub Category
                              <img
                                className="filter-icon"
                                src={getArrowImage("te_contentSubType")}
                                onClick={() => handleSort("te_contentSubType")}
                                alt={
                                  sortDirection === "asc"
                                    ? "Sort Ascending"
                                    : "Sort Descending"
                                }
                              />
                            </th>
                            <th> </th>
                          </tr>
                        </thead>
                        <tbody>
                          {sortedData(filteredContenttype).map((item) => (
                            <tr key={item.te_contentname}>
                              <td
                                onClick={() => handleContentClick(item)}
                                style={{ cursor: "pointer" }}
                              >
                                <div
                                  className="invoice-number"
                                  title={item.te_contentname}
                                  dangerouslySetInnerHTML={{
                                    __html: highlightText(
                                      item.te_contentname,
                                      searchTerm
                                    ),
                                  }}
                                />
                              </td>
                              <td
                                dangerouslySetInnerHTML={{
                                  __html: highlightText(
                                    item.te_filesize ? item.te_filesize : "N/A",
                                    searchTerm
                                  ),
                                }}
                              />
                              <td
                                onClick={() => handleContentClick(item)}
                                style={{ cursor: "pointer" }}
                                dangerouslySetInnerHTML={{
                                  __html: highlightText(
                                    item.te_contenttype
                                      ? item.te_contenttype
                                      : "N/A",
                                    searchTerm
                                  ),
                                }}
                              />

                              <td>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: highlightText(
                                      item.te_contentdate
                                        ? new Date(
                                          item.te_contentdate
                                        ).toLocaleDateString("en-GB")
                                        : "N/A",
                                      searchTerm
                                    ),
                                  }}
                                />
                              </td>
                              <td className="Last-Table">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: highlightText(
                                      item.te_contentSubType
                                        ? item.te_contentSubType
                                        : "N/A",
                                      searchTerm
                                    ),
                                  }}
                                />
                              </td>
                              <td>
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#FFD119",
                                  }}
                                >
                                  <GetAppIcon
                                    style={{
                                      marginLeft: "20px",
                                      cursor: "pointer",
                                      fontSize: "20px",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      downloadFile(
                                        item.te_contenturl,
                                        item.te_contentname
                                      );
                                    }}
                                    title="Download"
                                  />
                                  <img
                                    className="delete-svg"
                                    src={deletesvg}
                                    alt="Delete"
                                    style={{
                                      paddingLeft: "20px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openDeleteModal(
                                        item.te_contentid,
                                        item.te_contenttype
                                      );
                                    }}
                                  />
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  </div>
                  {/* <div style={{ alignContent: "center" }}>
                    <TableRight
                      style={{
                        width: "300px",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div> */}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Download Progress Indicator */}
        {downloadingFile && (
          <div style={{
            position: 'fixed',
            top: '10px',
            right: '10px',
            backgroundColor: '#1A1A1A',
            border: '1px solid #FFD119',
            borderRadius: '5px',
            padding: '15px',
            zIndex: 9999,
            width: '300px',
          }}>
            <Typography variant="body2" style={{ color: '#fff', marginBottom: '5px' }}>
              Downloading... {downloadProgress}%
            </Typography>
            <div style={{
              width: '100%',
              height: '10px',
              backgroundColor: '#333',
              borderRadius: '5px',
              overflow: 'hidden'
            }}>
              <div style={{
                width: `${downloadProgress}%`,
                height: '100%',
                backgroundColor: '#FFD119',
                transition: 'width 0.3s ease-in-out'
              }} />
            </div>
          </div>
        )}
      </div>
      <Modal
        open={openPopup}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <button className="close-popup" onClick={handleClose}>
            x
          </button>
          <AddContent closeContentPopup={closeContentPopup} />
        </Box>
      </Modal>

      <Modal
        open={isDeleteOpen}
        onClose={closeDeleteModal}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <Box sx={styledelete}>
          <Typography id="delete-modal-title" variant="h6" component="h2">
            Confirm Delete
          </Typography>
          <Typography id="delete-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete the {selectedcontentType}?
          </Typography>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <button
              onClick={closeDeleteModal}
              style={{
                color: "white",
                marginLeft: "10px",
                borderRadius: "5px",
                padding: "5px 10px",
                background: "#6c757d",
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => DeleteUser(selectedcontentID)}
              className="delete-button"
              style={{
                background: "#FFD119",
                marginLeft: "10px",
                borderRadius: "5px",
                padding: "5px 10px",
              }}
            >
              Delete
            </button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={viewedItem !== null}
        onClose={() => setViewedItem(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
       >
        <Box sx={modalStyle}>
          <IconButton
            aria-label="close"
            onClick={() => setViewedItem(null)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "black",
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Loading indicator */}
          {viewedItem && viewedItem.loading && (
            <div style={{ textAlign: "center" }}>
              <CircularProgress style={{ color: "black" }} />
              <Typography
                variant="body1"
                style={{ marginTop: 10, color: "FFD119" }}
              >
                Loading content...
              </Typography>
            </div>
          )}

          {/* Image content */}
          {viewedItem &&
  viewedItem.te_contenttype === "image" &&
  !viewedItem.loading && (
    <div
      style={{
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        padding: "40px", 
        display: "flex",
        flexDirection: "column", //s tack vertically
        alignItems: "center",    // center horizontally
        justifyContent: "center",
      }}
    >
      <img
        src={viewedItem.te_contenturl}
        alt={viewedItem.te_contentname}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
          marginBottom: "20px", // spacing between image and button
        }}
      />
      <button
        style={downloadButtonStyle}
        onClick={() =>
          downloadFile(viewedItem.te_contenturl, viewedItem.te_contentname)
        }
      >
        <GetAppIcon /> Download Image
      </button>
    </div>
)}


          {/* ZIP file content */}
          {viewedItem &&
            viewedItem.isZip &&
            !viewedItem.loading && (
              <div style={{
                textAlign: "center",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "80%"
              }}>
                <div style={{
                  padding: "20px",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                  border: "1px solid #ddd",
                  marginBottom: "20px",
                  maxWidth: "80%"
                }}>


                  <p style={{ color: "#555", marginBottom: "20px" }}>
                    ZIP files cannot be previewed directly in the browser.
                    To view the contents, please download the file and extract it on your device.
                  </p>

                </div>

                <button
                  style={downloadButtonStyle}
                  onClick={() => downloadFile(viewedItem.te_contenturl, viewedItem.te_contentname)}
                >
                  <GetAppIcon /> Download ZIP File
                </button>
              </div>
            )
          }
          {/* Text file content */}
          {viewedItem &&
            viewedItem.te_contenttype === "file" &&
            viewedItem.te_contentname.endsWith(".txt") &&
            !viewedItem.loading && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <iframe
                  src={viewedItem.te_contenturl}
                  title={viewedItem.te_contentname}
                  style={{
                    ...contentStyle,
                    width: "100%",
                    height: "80%",
                    border: "none",
                  }}
                />
                <button
                  style={downloadButtonStyle}
                  onClick={() =>
                    downloadFile(
                      viewedItem.te_contenturl,
                      viewedItem.te_contentname
                    )
                  }
                >
                  <GetAppIcon /> Download File
                </button>
              </div>
            )}

          {/* Replace your existing PDF viewer code with this: */}

          {/* PDF content */}
          
          {viewedItem &&
            ((viewedItem.te_contenttype === "file" && viewedItem.isPdf) ||
              viewedItem.te_contentname.toLowerCase().endsWith(".pdf")) &&
            !viewedItem.loading && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {viewedItem.pdfError ? (
                  <div style={{ textAlign: "center", marginBottom: "20px" }}>
                    <Typography variant="h6" style={{ color: "red" }}>
                      Error loading PDF preview
                    </Typography>
                    <Typography variant="body1">
                      The PDF could not be loaded for preview. Please download
                      it instead.
                    </Typography>
                  </div>
                ) : (
                  <iframe
                    src={viewedItem.blobUrl}
                    title={viewedItem.te_contentname}
                    style={{
                      width: "100%",
                      height: "80%",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                )}
                <button
                  style={downloadButtonStyle}
                  onClick={() =>
                    downloadFile(
                      viewedItem.te_contenturl,
                      viewedItem.te_contentname
                    )
                  }
                >
                  <GetAppIcon /> Download PDF
                </button>
              </div>
            )}
          {viewedItem &&
            viewedItem.te_contenttype === "file" &&
            (viewedItem.te_contentfilepath?.endsWith(".docx") ||
              viewedItem.te_contenturl?.endsWith(".docx")) && (
              <>
                <div>
                  <p>
                    DOCX files cannot be previewed directly. You can download
                    the file to view it.
                  </p>
                  <button
                    onClick={() =>
                      downloadFile(
                        viewedItem.te_contenturl,
                        viewedItem.te_contentname
                      )
                    }
                  >
                    Download DOCX
                  </button>
                </div>
              </>
            )}
          {viewedItem &&
            viewedItem.te_contenttype === "3dobject" &&
            (viewedItem.te_contentfilepath?.endsWith(".fbx") ||
              viewedItem.te_contenturl?.endsWith(".fbx") ||
              viewedItem.te_contentfilepath?.endsWith(".obj") ||
              viewedItem.te_contenturl?.endsWith(".obj")) && (
              <>
                <div>
                  <p>
                    3D files cannot be previewed directly. You can download the
                    file to view it.
                  </p>
                  <button
                    style={downloadButtonStyle}
                    onClick={() =>
                      downloadFile(
                        viewedItem.te_contenturl,
                        viewedItem.te_contentname
                      )
                    }
                  >
                    <GetAppIcon />
                    Download 3D File
                  </button>
                </div>
              </>
            )}

          {viewedItem &&
            (viewedItem.te_contenttype === "text" ||
              viewedItem.te_contentname.endsWith(".txt")) && (
              <pre
                style={{
                  ...contentStyle,
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  overflow: "auto",
                }}
              >
                {viewedItem.textContent}
              </pre>
            )}
      {viewedItem &&
  viewedItem.te_contenttype === "video" &&
  !viewedItem.loading && (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      <video
        src={viewedItem.te_contenturl}
        controls
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      >
        Your browser does not support the video tag.
      </video>
              {/* <button 
           style={downloadButtonStyle}
            onClick={() => downloadFile(viewedItem.te_contenturl, viewedItem.te_contentname)}
           >
         <GetAppIcon /> Download Video
         </button> */}
            </div>
          )}
          {viewedItem && viewedItem.te_contentname.endsWith(".avi") && !viewedItem.loading && (
            <div style={{ textAlign: "center" }}>
              <p>Your browser does not support .avi file video element.</p>
              <button
                onClick={() =>
                  downloadFile(
                    viewedItem.te_contenturl,
                    viewedItem.te_contentname
                  )
                }
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#FFD119",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Download .avi File
              </button>
            </div>
          )}
          {viewedItem &&
            (viewedItem.te_contenttype === "audio" ||
              isAudioFile(viewedItem.te_contentname)) &&
            (viewedItem.te_contentname.toLowerCase().endsWith(".mp3") ? (
              <audio
                src={viewedItem.te_contenturl}
                controls
                style={audioStyle}
                onError={(e) => console.error("Audio error:", e)}
              >
                Your browser does not support the audio element.
              </audio>
            ) : (
              <div style={audioStyle}>
                <audio
                  src={viewedItem.te_contenturl}
                  controls
                  onError={(e) => console.error("Audio error:", e)}
                >
                  Your browser does not support the audio element.
                </audio>
                <p>If the audio doesn't play, you can download it instead:</p>
                <button
                  onClick={() =>
                    downloadFile(
                      viewedItem.te_contenturl,
                      viewedItem.te_contentname
                    )
                  }
                >
                  Download Audio
                </button>
              </div>
            ))}
        </Box>
      </Modal>
    </div>
  );
}

export default ContentList;
